import { AnimatePresence, motion, usePresenceData } from 'motion/react'
import { createContext, forwardRef, useState } from 'react'

import {
  steps as advanceSteps,
  useTakeAdvance,
} from '@/containers/onDemandPay/TakeAdvance/TakeAdvanceContext'

const stepOrder = [
  'AdvanceDestination',
  'AdvanceAmount',
  'AdvanceConfirmation',
  'AdvanceResult',
] as const

export type AdvanceContext = {
  contentOverflow: boolean
  setContentOverflow: (contentOverflow: boolean) => void
}

export const AdvanceStepsContext = createContext<AdvanceContext | null>(null)

const Slide = forwardRef(function Slide(
  { children }: { children: React.ReactNode },
  ref: React.Ref<HTMLDivElement>
) {
  const direction = usePresenceData()
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x: direction * 400 }}
      animate={{
        opacity: 1,
        x: 0,
      }}
      transition={{ duration: 0.3 }}
      exit={{ opacity: 0, x: direction * -400 }}
      style={{ flex: 1, overflow: 'hidden' }}
    >
      {children}
    </motion.div>
  )
})

export const TakeAdvanceSteps = () => {
  const { currentStep, previousStep } = useTakeAdvance()
  const [contentOverflow, setContentOverflow] = useState<boolean>(false)
  const StepComponent = advanceSteps[currentStep]

  const currentIndex = stepOrder.indexOf(currentStep)
  const previousIndex = stepOrder.indexOf(previousStep)
  const direction =
    currentStep === previousStep ? 1 : currentIndex > previousIndex ? 1 : -1

  return (
    <AdvanceStepsContext
      value={{
        contentOverflow,
        setContentOverflow,
      }}
    >
      <AnimatePresence custom={direction} initial={false} mode="popLayout">
        <Slide key={currentStep}>
          <StepComponent />
        </Slide>
      </AnimatePresence>
    </AdvanceStepsContext>
  )
}
